import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const COMPANY = {
  name: "YOUCARS S.R.L.",
  address: "Corso Bergamo, 108/D",
  city: "23900 Lecco (LC)",
  piva: "03288340130",
  cf: "03288340130",
  rea: "LC 312320",
  phone: "3938398608",
  phoneDisplay: "+39 393 839 8608",
  email: "info@youcars-srl.it",
  mapEmbed: "https://www.google.com/maps?q=Corso+Bergamo+108%2FD,+23900+Lecco+LC&output=embed",
  mapLink: "https://www.google.com/maps/search/?api=1&query=Corso+Bergamo+108%2FD+23900+Lecco+LC",
};

export const waLink = (msg = "Buongiorno YOUCARS, vorrei informazioni.") =>
  `https://wa.me/39${COMPANY.phone}?text=${encodeURIComponent(msg)}`;
export const telLink = `tel:+39${COMPANY.phone}`;
export const mailLink = (subject = "Richiesta informazioni") =>
  `mailto:${COMPANY.email}?subject=${encodeURIComponent(subject)}`;

export const photoUrl = (p) => `${API}/photos/${p}`;

export const formatPrice = (v) =>
  new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(v ?? 0);
export const formatKm = (v) => `${new Intl.NumberFormat("it-IT").format(v)} km`;

export const carTitle = (c, fallback = "Veicolo disponibile") => [c?.marca, c?.modello].filter(Boolean).join(" ") || fallback;

export const fetchCars = async () => {
  try {
    const res = await axios.get(`${API}/cars`);
    return Array.isArray(res.data) ? res.data : [];
  } catch {
    return [];
  }
};

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -72 });
  else el.scrollIntoView({ behavior: "smooth" });
};
